import { createDirectReportsBreadcrumbsContext } from "@/components/shared/DirectReportsBreadcrumbsContext";
import {
  AverageTimeSpentDirectReportsResponse,
  ReportType,
  SettingsPeriod
} from "@/entities/reporting/types";

const { BreadcrumbsProvider, useBreadcrumbs } =
  createDirectReportsBreadcrumbsContext<AverageTimeSpentDirectReportsResponse>({
    reportType: ReportType.AVG_TIME_SPENT,
    responseKey: "avgTimeSpent",
    defaultPeriod: SettingsPeriod.ALL_TIMES,
    getUserIds: (data) => data?.directReports?.map((dr: any) => dr.id) || []
  });

export const StageDurationBreadcrumbsProvider = BreadcrumbsProvider;
export const useStageDurationBreadcrumbs = useBreadcrumbs;
